import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";//Dto is a data transfer object
import { FieldType } from "@gbs-platform-client/fwk-core";

export class Adminportal extends EntityDto implements IEntityDto{
    Admin_Id:number;
User_Id : number;
User_Name: string;
Entity_Id:number;
Entity_Name:string;
Emp_Ref_Id:number;
Emp_Name:string;
Vendor_Id:number;
Vendor_Name:string;
Location_Id:string;
LocationName:string;
UserTypeId:number;
UserTypeName:string;
Email_Id:string;
PhoneNumber:string;
TotalCount:number;
Role_Id:number;
// approvalModeList: UserRole[];
// UserRoles: Array<UserRole>;
constructor(){
    super();
    this.Admin_Id=0;
    this.User_Id=0;
    this.User_Name="";
    this.Entity_Id=0;
    this.Entity_Name="";
    this.Emp_Ref_Id=0;
    this.Emp_Name="";
    this.Vendor_Id=0;
    this.Vendor_Name="";
    this.Location_Id="";
    this.LocationName="";
    this.UserTypeId=0;
    this.UserTypeName="";
    this.Email_Id="";
    this.PhoneNumber="";
    this.Role_Id=0;
    this.TotalCount=0;
    // this.approvalModeList = [];
    // this.UserRoles = [];
}
}